import { Component, Input, OnDestroy, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { PointStoreProductService } from '../../../marketplace/admin/services/point-store-product.service';
import { PointStoreCategoriesService } from '../../../marketplace/admin/services/point-store-categories.service';
import { PointStoreProductEditService } from '../../../marketplace/admin/services/point-store-product-edit.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import moment from 'moment';
import { ValidatorService } from '../../services/validator.service';
import OverlayScrollbars from 'overlayscrollbars';
import { takeUntil } from 'rxjs/operators';
import { MatStepper } from '@angular/material/stepper';
import { PointStoreProductEdit } from '../../models/point-store-product-edit.model';

@Component({
  selector: 'cv-point-store-product-setting-cxone',
  templateUrl: './cv-point-store-product-setting-cxone.component.html',
  styleUrls: ['./cv-point-store-product-setting-cxone.component.scss']
})
export class CvPointStoreProductSettingCxoneComponent implements OnInit, OnDestroy {
  @Input() formDataBinding: FormGroup;
  @Input() stepper:MatStepper;
  pscs: any = null;
  pspes: PointStoreProductEdit = null;

  carouselStart = new Date();
  carouselEnd = new Date();

  featureStart = new Date();
  featureEnd = new Date();

  saleStart = new Date();
  saleEnd = new Date();

  formSelectedDate = new Date();

  addDiscount: boolean = false;

  addFeature: boolean;
  endDateCarousel: boolean = false;
  endDateFeaturedProduct: boolean = false;
  endDateSale: boolean = false;
  HasProductVariations: boolean = true;
  percentageInput: number;
  selectAll: boolean = false;
  variationSaleIsValid: boolean = false;
  localizationStrings = new Map();
  disabledPercentageValue: boolean = false;
  private ngUnsubscribe = new Subject();
  private ngUnsubscribeVariations = new Subject<void>();

  constructor(
    private pointStoreProductService: PointStoreProductService,
    private pointStoreCategoriesService: PointStoreCategoriesService,
    private pointStoreProductEditService: PointStoreProductEditService,
    private cvLocalizationFactory: CVLocalizationService,
    public cvLocalizationService: CVLocalizationService,
    public validatorService: ValidatorService,
    private renderer: Renderer2, 
    private elementRef: ElementRef
  ) {
  }
  async ngOnInit(): Promise<void> {
    this.initForm();
    this.pscs = this.pointStoreCategoriesService.data;
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
    await this.loadLocalizations();
  }

  ngAfterViewInit() {
    this.carouselStart = this.validatorService.truncateDate(new Date(), true);
    this.carouselEnd = this.validatorService.truncateDate(new Date());

    this.featureStart = this.validatorService.truncateDate(new Date(), true);
    this.featureEnd = this.validatorService.truncateDate(new Date());

    this.saleStart = this.validatorService.truncateDate(new Date(), true);
    this.saleEnd = this.validatorService.truncateDate(new Date());

    
    this.stepper.selectionChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((step) => {
        if (step.selectedIndex === 1) {
            this.checkSale();
        }
    });
    this.validatorService.variationObservable$
        .pipe(takeUntil(this.ngUnsubscribeVariations))
        .subscribe((data) => {
            this.checkSale();
        });
    this.fillForm();
  }

    removeReadOnlyAttr(id: string) {
        setTimeout(() => {
            let element = this.elementRef.nativeElement.querySelector(`#${id}`);
            if (element && element.hasAttribute('readonly')) {
                this.renderer.removeAttribute(element, 'readonly');
            }
        }, 100);
    }

    ngOnDestroy() {
      this.ngUnsubscribe.next({});
      this.ngUnsubscribe.complete();
      this.ngUnsubscribeVariations.next();
      this.ngUnsubscribeVariations.complete();
    }

  initForm(): void {
    this.formSelectedDate.setHours(0);
    this.formSelectedDate.setMinutes(0);
    this.formSelectedDate.setSeconds(0);

    //carousel start
    const formCarouselStart = new FormControl(this.carouselStart, []);
    this.formDataBinding.addControl('carouselStart', formCarouselStart);
    //carousel end
    const formCarouselEnd = new FormControl(this.carouselEnd, []);
    this.formDataBinding.addControl('carouselEnd', formCarouselEnd);
    //validations for carousel dates
    const formCarouselDates = new FormControl(false, [this.validatorService.dateRangeValidator('settings')]);
    this.formDataBinding.addControl('carouselDates', formCarouselDates);
    //Add feature label
    const formAddToFeature = new FormControl();
    this.formDataBinding.addControl('addToFeature', formAddToFeature);
    //feature start
    const formFeatureStart = new FormControl(this.carouselStart, []);
    this.formDataBinding.addControl('featureStart', formFeatureStart);
    //feature end
    const formFeatureEnd = new FormControl(this.featureEnd, []);
    this.formDataBinding.addControl('featureEnd', formFeatureEnd);
    //validations for feature dates
    const formFeatureDates = new FormControl(false, [this.validatorService.dateRangeValidator('settings')]);
    this.formDataBinding.addControl('featureDates', formFeatureDates);
    const formSaleStart = new FormControl(this.saleStart, []);
    this.formDataBinding.addControl('saleStart', formSaleStart);
    const formSaleEnd = new FormControl(this.saleEnd, []);
    this.formDataBinding.addControl('saleEnd', formSaleEnd);
    //validations for sale dates
    const formSaleDates = new FormControl(false, [this.validatorService.dateRangeValidator('settings')]);
    this.formDataBinding.addControl('saleDates', formSaleDates);
   //checkbox
    const formEndDateCarousel = new FormControl();
    this.formDataBinding.addControl('endDateCarousel', formEndDateCarousel);
    const formEndDateFeature = new FormControl();
    this.formDataBinding.addControl('endDateFeature', formEndDateFeature);
    const formEndDateDiscount = new FormControl();
    this.formDataBinding.addControl('endDateDiscount', formEndDateDiscount);
    const formAllVariations = new FormControl();
    this.formDataBinding.addControl('allVariations', formAllVariations);
    // percentage
    const formPercentageInput = new FormControl();
    this.formDataBinding.addControl('percentageInput', formPercentageInput);
  }

  async loadLocalizations(): Promise<void> {
    this.localizationStrings = await this.cvLocalizationService.GetSection("MarketPlace_Management");
  }

  prodSettingsOptions: OverlayScrollbars.PartialOptions = {
    scrollbars: {
      visibility: 'visible',
      autoHide: "leave",
      autoHideDelay: 100,
      theme: "custom-scrollbar"
    },
    overflow: {
      x: 'hidden',
      y: 'scroll'
    },
  };

  getLocalizationString(key, defaultValue) {
    if (this.localizationStrings && this.localizationStrings.has(key))
      return this.localizationStrings.get(key);
    return defaultValue;
  }

  checkboxChanged_showInCarousel() {
    this.removeReadOnlyAttr('dpCarouselStart');
    this.removeReadOnlyAttr('dpCarouselEnd');
    if (this.pspes.settingPointStoreProduct.Carousel) {
      if (this.pspes.modifiedPointStoreProduct.CarouselStart_ForView == null || this.pspes.modifiedPointStoreProduct.CarouselStart_ForView.length <= 0) {
        this.pspes.modifiedPointStoreProduct.CarouselStart = this.pspes.modifiedPointStoreProduct.ProductStart ? this.validatorService.truncateDate(new Date(this.pspes.modifiedPointStoreProduct.ProductStart), true) : null;
        this.pspes.modifiedPointStoreProduct.CarouselStart_ForView = this.pspes.modifiedPointStoreProduct.ProductStart_ForView;
        this.pspes.modifiedPointStoreProduct.CarouselEnd_ForView =  this.pspes.modifiedPointStoreProduct.ProductStart_ForView;

        this.carouselStart = this.pspes.modifiedPointStoreProduct.ProductStart ? this.validatorService.truncateDate(new Date(this.pspes.modifiedPointStoreProduct.ProductStart), true) : null;
        this.formDataBinding.controls['carouselStart'].setValue(this.carouselStart);
        this.carouselEnd = this.pspes.modifiedPointStoreProduct.ProductStart ? this.validatorService.truncateDate(new Date(this.pspes.modifiedPointStoreProduct.ProductStart)) : null;
        this.formDataBinding.controls['carouselEnd'].setValue(this.carouselEnd);
        this.pspes.modifiedPointStoreProduct.CarouselEnd = this.carouselEnd;
        this.pspes.modifiedPointStoreProduct.CarouselEnd_ForView = moment(this.carouselEnd).format(CVMomentDateFormat);
      }
    }
    else {
      this.pspes.modifiedPointStoreProduct.CarouselStart = null;
      this.pspes.modifiedPointStoreProduct.CarouselStart_ForView = null;
      this.pspes.modifiedPointStoreProduct.CarouselEnd = null;
      this.pspes.modifiedPointStoreProduct.CarouselEnd_ForView = null;
      this.formDataBinding.controls['carouselDates'].setValue(false);
      this.carouselEnd = this.pspes.modifiedPointStoreProduct.ProductStart;
    }
    this.pspes.modifiedPointStoreProduct.IsCarouselChecked = this.pspes.settingPointStoreProduct.Carousel;
    this.enableDisableCarouselDatesValidators(this.pspes.settingPointStoreProduct.Carousel);
    this.endDateCarousel = false;
  };

  checkboxChangedEndDateCarousel(): void {
    this.removeReadOnlyAttr('dpCarouselEnd');
    if (this.endDateCarousel) {
      this.pspes.modifiedPointStoreProduct.CarouselEnd = null;
      this.pspes.modifiedPointStoreProduct.CarouselEnd_ForView = null;
      this.carouselEnd = null;
      this.formDataBinding.controls['carouselDates'].setValue(false);
      this.formDataBinding.controls['carouselEnd'].setValidators([]);
      this.formDataBinding.controls['carouselEnd'].updateValueAndValidity();
    } else {
      this.carouselStart = this.validatorService.truncateDate(this.carouselStart, true);
      this.carouselEnd = this.validatorService.truncateDate(this.carouselStart);
      this.formDataBinding.controls['carouselEnd'].setValidators([Validators.required]);
      this.formDataBinding.controls['carouselEnd'].updateValueAndValidity();
      this.setDateToEndDateCarousel(this.carouselEnd);
    }
  }

  setDateToEndDateCarousel(date?: Date) {
    let validateDate = date;
    if (date) {
        if (this.pspes.modifiedPointStoreProduct.CarouselStart && date < this.pspes.modifiedPointStoreProduct.CarouselStart) {
          this.formDataBinding.controls['carouselDates'].setValue(true);
          this.formDataBinding.controls['carouselDates'].markAsTouched();
        } else {
          this.formDataBinding.controls['carouselDates'].setValue(false);
        }
        validateDate = this.validatorService.truncateDate(date);
    }
    if (this.pspes.modifiedPointStoreProduct.CarouselStart) this.pspes.modifiedPointStoreProduct.CarouselEnd = validateDate ? validateDate : null;
    this.pspes.modifiedPointStoreProduct.CarouselEnd_ForView = !validateDate ? null : moment(validateDate).format(CVMomentDateFormat);
    this.formDataBinding.controls['carouselEnd'].setValue(validateDate);
    this.formDataBinding.controls['carouselEnd'].markAsTouched();
  }

  setCarouselStart(date?: Date) {
    if (date) {
      if (this.pspes.modifiedPointStoreProduct.CarouselEnd && date > this.pspes.modifiedPointStoreProduct.CarouselEnd) {
        this.formDataBinding.controls['carouselDates'].setValue(true);
        this.formDataBinding.controls['carouselDates'].markAsTouched();
      } else {
        this.formDataBinding.controls['carouselDates'].setValue(false);
      }
      date=this.validatorService.truncateDate(date, true);
    }
    this.pspes.modifiedPointStoreProduct.CarouselStart = date ? date : null;
    this.pspes.modifiedPointStoreProduct.CarouselStart_ForView = !date ? null : moment(date).format(CVMomentDateFormat);
    this.formDataBinding.controls['carouselStart'].setValue(date);
    this.formDataBinding.controls['carouselStart'].markAsTouched();
  }

  setCarouselEnd(date?: Date) {
    let validateDate = date;
    if (date) {
      if (this.pspes.modifiedPointStoreProduct.CarouselStart && date < this.pspes.modifiedPointStoreProduct.CarouselStart) {
        this.formDataBinding.controls['carouselDates'].setValue(true);
        this.formDataBinding.controls['carouselDates'].markAsTouched();
      } else {
        this.formDataBinding.controls['carouselDates'].setValue(false);
      }
      validateDate = this.validatorService.truncateDate(date);
    }
    this.pspes.modifiedPointStoreProduct.CarouselEnd = validateDate ? validateDate : null;
    this.pspes.modifiedPointStoreProduct.CarouselEnd_ForView = !validateDate ? null : moment(validateDate).format(CVMomentDateFormat);
    this.formDataBinding.controls['carouselEnd'].setValue(validateDate);
    this.formDataBinding.controls['carouselEnd'].markAsTouched();
  }

  enableDisableCarouselDatesValidators(isActive: boolean): void {
    if (isActive) {
      this.formDataBinding.controls['carouselStart'].setValidators([Validators.required]);
      this.formDataBinding.controls['carouselStart'].updateValueAndValidity();
      this.formDataBinding.controls['carouselEnd'].setValidators([Validators.required]);
      this.formDataBinding.controls['carouselEnd'].updateValueAndValidity();
      this.formDataBinding.controls['carouselDates'].setValidators([this.validatorService.dateRangeValidator('settings')]);
      this.formDataBinding.controls['carouselDates'].updateValueAndValidity();
    } else {
      this.formDataBinding.controls['carouselStart'].setValidators([]);
      this.formDataBinding.controls['carouselStart'].updateValueAndValidity();
      this.formDataBinding.controls['carouselEnd'].setValidators([]);
      this.formDataBinding.controls['carouselEnd'].updateValueAndValidity();
      this.formDataBinding.controls['carouselDates'].setValidators([]);
      this.formDataBinding.controls['carouselDates'].updateValueAndValidity();
    }
  }

  checkboxChanged_showInFeatured() {
    this.removeReadOnlyAttr('dpFeatureStart');
    this.removeReadOnlyAttr('dpFeatureEnd');
    if (this.pspes.settingPointStoreProduct.FeaturedProduct) {
      if (this.pspes.modifiedPointStoreProduct.FeatureStart_ForView == null || this.pspes.modifiedPointStoreProduct.FeatureStart_ForView.length <= 0) {
        this.pspes.modifiedPointStoreProduct.FeatureStart = this.pspes.modifiedPointStoreProduct.ProductStart ? this.validatorService.truncateDate(new Date(this.pspes.modifiedPointStoreProduct.ProductStart), true) : null;
        this.pspes.modifiedPointStoreProduct.FeatureStart_ForView = this.pspes.modifiedPointStoreProduct.ProductStart_ForView;
        this.pspes.modifiedPointStoreProduct.FeatureEnd_ForView = this.pspes.modifiedPointStoreProduct.ProductStart_ForView;
        this.featureStart = this.pspes.modifiedPointStoreProduct.ProductStart ? this.validatorService.truncateDate(new Date(this.pspes.modifiedPointStoreProduct.ProductStart), true) : null;
        this.formDataBinding.controls['featureStart'].setValue(this.featureStart);
        this.featureEnd = this.pspes.modifiedPointStoreProduct.ProductStart ? this.validatorService.truncateDate(new Date(this.pspes.modifiedPointStoreProduct.ProductStart)) : null;
        this.formDataBinding.controls['featureEnd'].setValue(this.featureEnd);
        this.pspes.modifiedPointStoreProduct.FeatureEnd = this.featureEnd;
        this.pspes.modifiedPointStoreProduct.FeatureEnd_ForView = moment(this.featureEnd).format(CVMomentDateFormat);
      }
    }
    else {
      this.pspes.modifiedPointStoreProduct.FeatureStart = null;
      this.pspes.modifiedPointStoreProduct.FeatureStart_ForView = null;
      this.pspes.modifiedPointStoreProduct.FeatureEnd = null;
      this.pspes.modifiedPointStoreProduct.FeatureEnd_ForView = null;
      this.formDataBinding.controls['featureDates'].setValue(false);
      this.featureEnd = this.pspes.modifiedPointStoreProduct.ProductStart;
    }
    this.pspes.modifiedPointStoreProduct.IsFeaturedChecked = this.pspes.settingPointStoreProduct.FeaturedProduct;
    this.enableDisableFeatureDatesValidators(this.pspes.settingPointStoreProduct.FeaturedProduct);
    this.endDateFeaturedProduct = false;
    this.formDataBinding.controls['addToFeature'].setValue(this.pspes.settingPointStoreProduct.FeaturedProduct);
  };

  enableDisableFeatureDatesValidators(isActive: boolean): void {
    if (isActive) {
      this.formDataBinding.controls['featureStart'].setValidators([Validators.required]);
      this.formDataBinding.controls['featureStart'].updateValueAndValidity();
      this.formDataBinding.controls['featureEnd'].setValidators([Validators.required]);
      this.formDataBinding.controls['featureEnd'].updateValueAndValidity();
      this.formDataBinding.controls['featureDates'].setValidators([this.validatorService.dateRangeValidator('settings')]);
      this.formDataBinding.controls['featureDates'].updateValueAndValidity();
    } else {
      this.formDataBinding.controls['featureStart'].setValidators([]);
      this.formDataBinding.controls['featureStart'].updateValueAndValidity();
      this.formDataBinding.controls['featureEnd'].setValidators([]);
      this.formDataBinding.controls['featureEnd'].updateValueAndValidity();
      this.formDataBinding.controls['featureDates'].setValidators([]);
      this.formDataBinding.controls['featureDates'].updateValueAndValidity();
    }
  }

  setFeatureStart(date?: Date) {
    if (date) {
      if (this.pspes.modifiedPointStoreProduct.FeatureEnd && date > this.pspes.modifiedPointStoreProduct.FeatureEnd) {
        this.formDataBinding.controls['featureDates'].setValue(true);
        this.formDataBinding.controls['featureDates'].markAsTouched();
      } else {
        this.formDataBinding.controls['featureDates'].setValue(false);
      }
      date = this.validatorService.truncateDate(date, true);
    }
    this.pspes.modifiedPointStoreProduct.FeatureStart = date ? date : null;
    this.pspes.modifiedPointStoreProduct.FeatureStart_ForView = !date ? null : moment(date).format(CVMomentDateFormat);
    this.formDataBinding.controls['featureStart'].setValue(date);
    this.formDataBinding.controls['featureStart'].markAsTouched();
  }

  setFeatureEnd(date?: Date) {
    let validateDate = date;
    if (date) {
      if (this.pspes.modifiedPointStoreProduct.FeatureStart && date < this.pspes.modifiedPointStoreProduct.FeatureStart) {
        this.formDataBinding.controls['featureDates'].setValue(true);
        this.formDataBinding.controls['featureDates'].markAsTouched();
      } else {
        this.formDataBinding.controls['featureDates'].setValue(false);
      }
      validateDate = this.validatorService.truncateDate(date);
    }
    this.pspes.modifiedPointStoreProduct.FeatureEnd = validateDate ? validateDate : null;
    this.pspes.modifiedPointStoreProduct.FeatureEnd_ForView = !validateDate ? null : moment(validateDate).format(CVMomentDateFormat);
    this.formDataBinding.controls['featureEnd'].setValue(validateDate);
    this.formDataBinding.controls['featureEnd'].markAsTouched();
  }

  checkboxChangedEndDateFeature(): void {
    this.removeReadOnlyAttr('dpFeatureEnd');
    if (this.endDateFeaturedProduct) {
      this.pspes.modifiedPointStoreProduct.FeatureEnd = null;
      this.pspes.modifiedPointStoreProduct.FeatureEnd_ForView = null;
      this.featureEnd = null;
      this.formDataBinding.controls['featureDates'].setValue(false);
      this.formDataBinding.controls['featureEnd'].setValidators([]);
      this.formDataBinding.controls['featureEnd'].updateValueAndValidity();
    } else {
      this.featureStart = this.validatorService.truncateDate(this.featureStart, true);
      this.featureEnd = this.validatorService.truncateDate(this.featureStart);
      this.formDataBinding.controls['featureEnd'].setValidators([Validators.required]);
      this.formDataBinding.controls['featureEnd'].updateValueAndValidity();
      this.setDateToEndDateFeature(this.featureEnd);
    }
  }

  setDateToEndDateFeature(date?: Date) {
    let validateDate = date;
    if (date) {
        if (this.pspes.modifiedPointStoreProduct.FeatureStart && date < this.pspes.modifiedPointStoreProduct.FeatureStart) {
          this.formDataBinding.controls['featureDates'].setValue(true);
          this.formDataBinding.controls['featureDates'].markAsTouched();
        } else {
          this.formDataBinding.controls['featureDates'].setValue(false);
        }
        validateDate = this.validatorService.truncateDate(date);
      }
    if (this.pspes.modifiedPointStoreProduct.FeatureStart) this.pspes.modifiedPointStoreProduct.FeatureEnd = validateDate ? validateDate : null;
    this.pspes.modifiedPointStoreProduct.FeatureEnd_ForView = !validateDate ? null : moment(validateDate).format(CVMomentDateFormat);
    this.formDataBinding.controls['featureEnd'].setValue(validateDate);
    this.formDataBinding.controls['featureEnd'].markAsTouched();
  }

  // SALE
  checkboxChanged_showInOnSale() {
    this.removeReadOnlyAttr('dpSalesStart');
    this.removeReadOnlyAttr('dpSalesEnd');
    if (this.pspes.settingPointStoreProduct.Sale) {
      if (this.pspes.modifiedPointStoreProduct.SaleStart_ForView == null || this.pspes.modifiedPointStoreProduct.SaleStart_ForView.length <= 0) {
        this.pspes.modifiedPointStoreProduct.SaleStart = this.pspes.modifiedPointStoreProduct.ProductStart ? this.validatorService.truncateDate(new Date(this.pspes.modifiedPointStoreProduct.ProductStart), true) : null;
        this.pspes.modifiedPointStoreProduct.SaleStart_ForView = this.pspes.modifiedPointStoreProduct.ProductStart_ForView;
        this.pspes.modifiedPointStoreProduct.SaleEnd_ForView = this.pspes.modifiedPointStoreProduct.ProductStart_ForView;
        this.saleStart = this.pspes.modifiedPointStoreProduct.ProductStart ? this.validatorService.truncateDate(new Date(this.pspes.modifiedPointStoreProduct.ProductStart), true) : null;
        this.formDataBinding.controls['saleStart'].setValue(this.saleStart);
        this.saleEnd = this.pspes.modifiedPointStoreProduct.ProductStart ? this.validatorService.truncateDate(new Date(this.pspes.modifiedPointStoreProduct.ProductStart)) : null;
        this.formDataBinding.controls['saleEnd'].setValue(this.saleEnd);
        this.pspes.modifiedPointStoreProduct.SaleEnd = this.saleEnd;
        this.pspes.modifiedPointStoreProduct.SaleEnd_ForView = moment(this.saleEnd).format(CVMomentDateFormat);
        this.formDataBinding.controls['saleDates'].setValue(false);
      }
    }
    else {
      this.pspes.modifiedPointStoreProduct.SaleStart = null;
      this.pspes.modifiedPointStoreProduct.SaleStart_ForView = null;
      this.pspes.modifiedPointStoreProduct.SaleEnd = null;
      this.pspes.modifiedPointStoreProduct.SaleEnd_ForView = null;
      this.percentageInput = null;
      this.formDataBinding.controls['percentageInput'].setValue(this.percentageInput);
      this.formDataBinding.controls['percentageInput'].markAsUntouched();
      this.setPercentageValue(null);
      this.uncheckAll();
      this.saleEnd = this.pspes.modifiedPointStoreProduct.ProductStart;
    }
    this.pspes.modifiedPointStoreProduct.IsOnSaleChecked = this.pspes.settingPointStoreProduct.Sale;
    this.enableDisableSaleDatesValidators(this.pspes.settingPointStoreProduct.Sale);
    this.endDateSale = false;
    this.checkSale();
  };

  enableDisableSaleDatesValidators(isActive: boolean): void {
    if (isActive) {
      this.formDataBinding.controls['saleStart'].setValidators([Validators.required]);
      this.formDataBinding.controls['saleStart'].updateValueAndValidity();
      this.formDataBinding.controls['saleEnd'].setValidators([Validators.required]);
      this.formDataBinding.controls['saleEnd'].updateValueAndValidity();
      this.formDataBinding.controls['percentageInput'].setValidators([Validators.required]);
      this.formDataBinding.controls['percentageInput'].updateValueAndValidity();
      this.formDataBinding.controls['saleDates'].setValidators([this.validatorService.dateRangeValidator('settings')]);
      this.formDataBinding.controls['saleDates'].updateValueAndValidity();
    } else {
      this.formDataBinding.controls['saleStart'].setValidators([]);
      this.formDataBinding.controls['saleStart'].updateValueAndValidity();
      this.formDataBinding.controls['saleEnd'].setValidators([]);
      this.formDataBinding.controls['saleEnd'].updateValueAndValidity();
      this.formDataBinding.controls['percentageInput'].setValidators([]);
      this.formDataBinding.controls['percentageInput'].updateValueAndValidity();
      this.formDataBinding.controls['saleDates'].setValidators([]);
      this.formDataBinding.controls['saleDates'].updateValueAndValidity();
    }
  }

  setSaleStart(date?: Date) {
    if (date) {
      if (this.pspes.modifiedPointStoreProduct.SaleEnd && date > this.pspes.modifiedPointStoreProduct.SaleEnd) {
        this.formDataBinding.controls['saleDates'].setValue(true);
        this.formDataBinding.controls['saleDates'].markAsTouched();
      } else {
        this.formDataBinding.controls['saleDates'].setValue(false);
      }
      date = this.validatorService.truncateDate(date, true);
    }
    this.pspes.modifiedPointStoreProduct.SaleStart = date ? date : null;
    this.pspes.modifiedPointStoreProduct.SaleStart_ForView = !date ? null : moment(date).format(CVMomentDateFormat);
    this.formDataBinding.controls['saleStart'].setValue(date);
    this.formDataBinding.controls['saleStart'].markAsTouched();
  }

  setSaleEnd(date?: Date) {
    let validateDate = date;
    if (date) {
      if (this.pspes.modifiedPointStoreProduct.SaleStart && date < this.pspes.modifiedPointStoreProduct.SaleStart) {
        this.formDataBinding.controls['saleDates'].setValue(true);
        this.formDataBinding.controls['saleDates'].markAsTouched();
      } else {
        this.formDataBinding.controls['saleDates'].setValue(false);
      }
      validateDate = this.validatorService.truncateDate(date);
    }
    this.pspes.modifiedPointStoreProduct.SaleEnd = validateDate ? validateDate : null;
    this.pspes.modifiedPointStoreProduct.SaleEnd_ForView = !validateDate ? null : moment(validateDate).format(CVMomentDateFormat);
    this.formDataBinding.controls['saleEnd'].setValue(validateDate);
    this.formDataBinding.controls['saleEnd'].markAsTouched();
  }

  checkAll() {
    this.pspes.modifiedPointStoreProduct.VariationsData.forEach(variation => {
      variation.VariationOnSale = this.selectAll;
    });
    this.checkboxChanged_VariationOnSale();
  }

  uncheckAll() {
    this.selectAll = false;
    this.pspes.modifiedPointStoreProduct.VariationsData.forEach(variation => {
      variation.VariationOnSale = this.selectAll;
    });
  }

  checkboxChanged_VariationOnSale() {
    if (this.pspes.settingPointStoreProduct.Sale) {
      if (this.pspes.modifiedPointStoreProduct.SaleStart_ForView == null || this.pspes.modifiedPointStoreProduct.SaleStart_ForView.length <= 0) {
        this.pspes.modifiedPointStoreProduct.SaleStart = this.pspes.modifiedPointStoreProduct.ProductStart ? new Date(this.pspes.modifiedPointStoreProduct.ProductStart) : null;
        this.pspes.modifiedPointStoreProduct.SaleStart_ForView = this.pspes.modifiedPointStoreProduct.ProductStart_ForView;
      }
    }
    else {
      this.pspes.modifiedPointStoreProduct.SaleStart = null;
      this.pspes.modifiedPointStoreProduct.SaleStart_ForView = null;
      this.pspes.modifiedPointStoreProduct.SaleEnd = null;
      this.pspes.modifiedPointStoreProduct.SaleEnd_ForView = null;
    }
    this.pspes.modifiedPointStoreProduct.IsOnSaleChecked = this.pspes.settingPointStoreProduct.Sale;
    this.checkSale();
  }

  checkboxChangedEndDateSale(): void {
    this.removeReadOnlyAttr('dpSalesEnd');
    if (this.endDateSale) {
      this.pspes.modifiedPointStoreProduct.SaleEnd = null;
      this.pspes.modifiedPointStoreProduct.SaleEnd_ForView = null;
      this.saleEnd = null;
      this.formDataBinding.controls['saleDates'].setValue(false);
      this.formDataBinding.controls['saleEnd'].setValidators([]);
      this.formDataBinding.controls['saleEnd'].updateValueAndValidity();
      this.formDataBinding.controls['saleEnd'].markAsTouched();
    } else {
      this.saleStart = this.validatorService.truncateDate(this.saleStart, true);
      this.saleEnd = this.validatorService.truncateDate(this.saleStart);
      this.formDataBinding.controls['saleEnd'].setValidators([Validators.required]);
      this.formDataBinding.controls['saleEnd'].updateValueAndValidity();
      this.setDateToEndDateSale(this.saleEnd);
    }
  }

  setDateToEndDateSale(date?: Date) {
    let validateDate = date;
    if (date) {
        if (this.pspes.modifiedPointStoreProduct.SaleStart && date < this.pspes.modifiedPointStoreProduct.SaleStart) {
          this.formDataBinding.controls['saleDates'].setValue(true);
          this.formDataBinding.controls['saleDates'].markAsTouched();
        } else {
          this.formDataBinding.controls['saleDates'].setValue(false);
        }
        validateDate = this.validatorService.truncateDate(date);
    }
    if (this.pspes.modifiedPointStoreProduct.SaleStart) this.pspes.modifiedPointStoreProduct.SaleEnd = validateDate ? validateDate : null;
    this.pspes.modifiedPointStoreProduct.SaleEnd_ForView = !validateDate ? null : moment(validateDate).format(CVMomentDateFormat);
    this.formDataBinding.controls['saleEnd'].setValue(validateDate);
    this.formDataBinding.controls['saleEnd'].markAsTouched();
  }

  checkSale() {
    let itemsOnSale = 0;
    if (this.pspes.modifiedPointStoreProduct != undefined && this.pspes.modifiedPointStoreProduct.VariationsData != undefined && this.pspes.settingPointStoreProduct != null) {
      this.variationSaleIsValid = false;
      if (!this.pspes.modifiedPointStoreProduct.HasProductVariations && this.pspes.settingPointStoreProduct.Sale) {
        this.disabledPercentageValue = true;
        return;
      }
      if (this.pspes.modifiedPointStoreProduct.HasProductVariations) {
        this.pspes.modifiedPointStoreProduct.VariationsData.forEach((variation) => {
          if (variation.VariationOnSale) {
            this.variationSaleIsValid = true;
            itemsOnSale++;
          }
        });
        this.selectAll = itemsOnSale == this.pspes.modifiedPointStoreProduct.VariationsData.length;
        if (this.variationSaleIsValid) {
          this.disabledPercentageValue = true;
          return;
        }else{
            this.disabledPercentageValue = false;
            this.setPercentageValue(null);
            return;
        }
      }
    }
  }

  setPercentageValue(incomingPercentageValue?: any) {
    let value = null;
    if (typeof incomingPercentageValue === 'object') {
        value = incomingPercentageValue ? incomingPercentageValue?.target?.value : incomingPercentageValue; 
    } else {
        value = incomingPercentageValue;
    }
    const roundedPercentageValue = value ? Math.trunc(value) : null;
    this.percentageInput = roundedPercentageValue == 0 ? 1 : roundedPercentageValue;
    this.pspes.modifiedPointStoreProduct.Sale = roundedPercentageValue;
    this.formDataBinding.controls['percentageInput'].setValue(roundedPercentageValue);
  }
  
  validateKeyboardInput(event: KeyboardEvent): void {
    const forbiddenKeys = [".", ",", "-", "e", "+", "E"];
    if (forbiddenKeys.some((key)=> key === event.key)) {
        event.preventDefault();
        return;
    }
  }

  validateClipboardInput(event: any): void {
    setTimeout(() => {
      if (event.target.value) {
        if (!Number.isInteger(event.target.value)) {
          this.setPercentageValue(event.target.value);
          const inputPercentage: any = document.querySelector('#percentage-numeric-selector div .numeric-selector-value');
          inputPercentage.value = this.percentageInput;
        }
      } else {
        this.setPercentageValue(1);
        const inputPercentage: any = document.querySelector('#percentage-numeric-selector div .numeric-selector-value');
        inputPercentage.value = this.percentageInput;
      }
    }, 0);
  }
  
  focusPercentageValue() {
      this.formDataBinding.controls['percentageInput'].markAsTouched();
  }

  
  private fillForm(): void {
  
    if (this.pspes.modifiedPointStoreProduct.PointStoreProductID == 0 && !this.pspes.copiedProduct) {
      return;
    }

    if (this.pspes.modifiedPointStoreProduct.Sale != null) {
      this.addDiscount = true;
      this.formDataBinding.controls['saleStart'].setValidators([Validators.required]);
      this.formDataBinding.controls['saleStart'].updateValueAndValidity();
      this.formDataBinding.controls['saleEnd'].setValidators([Validators.required]);
      this.formDataBinding.controls['saleEnd'].updateValueAndValidity();  
      this.formDataBinding.controls['percentageInput'].setValidators([Validators.required]);
      this.formDataBinding.controls['percentageInput'].updateValueAndValidity();
      this.formDataBinding.controls['percentageInput'].patchValue(this.pspes.modifiedPointStoreProduct.Sale);
      this.percentageInput = this.pspes.modifiedPointStoreProduct.Sale;
    } else {
      this.addDiscount = false;
    }

    //carousel start
    if (this.pspes.modifiedPointStoreProduct.CarouselStart != null) {
      this.carouselStart = this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.CarouselStart, true);
      this.formDataBinding.controls['carouselStart'].patchValue(this.carouselStart);
    } else {
      this.carouselStart = this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.ProductStart, true);
      this.formDataBinding.controls['carouselStart'].patchValue(this.carouselStart);
    }

    //feature start
    if (this.pspes.modifiedPointStoreProduct.FeatureStart != null) {
      this.featureStart = this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.FeatureStart, true);
      this.formDataBinding.controls['featureStart'].patchValue(this.featureStart);
    } else {
      this.featureStart = this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.ProductStart, true);
      this.formDataBinding.controls['featureStart'].patchValue(this.featureStart);
    }
    //sale start
    if (this.pspes.modifiedPointStoreProduct.SaleStart != null) {
      this.saleStart = this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.SaleStart, true);
      this.formDataBinding.controls['saleStart'].patchValue(this.saleStart);
    } else {
      this.saleStart = this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.ProductStart, true);
      this.formDataBinding.controls['saleStart'].patchValue(this.saleStart);
    }
    //carousel end
    this.formDataBinding.controls['carouselEnd'].patchValue(this.pspes.modifiedPointStoreProduct.CarouselEnd ? this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.CarouselEnd) : this.pspes.modifiedPointStoreProduct.CarouselEnd);
    if (!this.pspes.modifiedPointStoreProduct.CarouselEnd) {
      this.endDateCarousel = this.pspes.modifiedPointStoreProduct.CarouselStart != null;
      this.carouselEnd = this.pspes.modifiedPointStoreProduct.CarouselStart ? this.pspes.modifiedPointStoreProduct.CarouselEnd : this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.CarouselStart);
      this.checkboxChangedEndDateCarousel();
    } else {
      this.carouselEnd = this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.CarouselEnd);
    }
    //feature end
    this.formDataBinding.controls['featureEnd'].patchValue(this.pspes.modifiedPointStoreProduct.FeatureEnd ? this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.FeatureEnd) : this.pspes.modifiedPointStoreProduct.FeatureEnd);
    if (!this.pspes.modifiedPointStoreProduct.FeatureEnd) {
      this.endDateFeaturedProduct = this.pspes.modifiedPointStoreProduct.FeatureStart != null;
      this.featureEnd = this.pspes.modifiedPointStoreProduct.FeatureStart ? this.pspes.modifiedPointStoreProduct.FeatureEnd : this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.FeatureStart);
      this.checkboxChangedEndDateFeature();
    } else {
      this.featureEnd = this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.FeatureEnd);
    }
    //sale end
    this.formDataBinding.controls['saleEnd'].patchValue(this.pspes.modifiedPointStoreProduct.SaleEnd ? this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.SaleEnd) : this.pspes.modifiedPointStoreProduct.SaleEnd);
    if (!this.pspes.modifiedPointStoreProduct.SaleEnd) {
      this.endDateSale = this.pspes.modifiedPointStoreProduct.SaleStart != null;
      this.saleEnd = this.pspes.modifiedPointStoreProduct.SaleStart ? this.pspes.modifiedPointStoreProduct.SaleEnd : this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.SaleStart);
      this.checkboxChangedEndDateSale();
    } else {
      this.saleEnd = this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.SaleEnd);
    }
  }
}

